import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-question-answer-line text-primary-500 mr-2"></i>
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm">关于吃瓜网站线路一的常见疑问解答</p>
          </div>
          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-3 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}